module.exports = __webpack_public_path__ + "media/images/850/REM_sleep_night_stars-59f289161e6dcbb18cf51e28a9b26f62.webp";